import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFilterMenuOutline, mdiFilterMultiple, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelFlight from '../../../../../components/extras/SidePanelFlight';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import SelectFlightType from '../../../../../components/selects/selectFlightTypes';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import TableFlights from '../../../../../components/tables/tableFlights';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemEquipment, ItemFlight } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, exportToExcel, getCookie, getUrlVersion, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';

export const CMAEquipmentsFlightLogsPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [stage, setStage] = useState("A")


  const { navigate } = useRouter();
  const { data, parameters, menu } = useGlobalState();
  const [flights, setFlights] = useState<ItemFlight[]>([]);
  const [flight, setFlight] = useState<ItemFlight>();
  const [userCount, setUserCount] = useState<number>(0);
  const [advanceFilter, setAdvanceFilter] = useState<boolean>(false);


  useEffect(() => {
    if (parameters.startDate && parameters.endDate && parameters.pilotType && parameters.groupTypeMasterCode) {
      //handleFlightsSearch()
    }
  }, [parameters.startDate, parameters.endDate, parameters.pilotType, parameters.groupTypeMasterCode, parameters.idCategories, parameters.idGroupTypes, parameters.idFlightTypes, parameters.idUser]);

  const mountedRef = useRef(false);
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id) {
        if (!mountedRef.current) {
          mountedRef.current = true;
          handleFlightsSearch()
        }
        setFlight(undefined)
        handleGetFlight(parseInt(id))
      } else {
        setFlight(undefined)
        //handleFlightsSearch();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  const handleExcel = () => {
    let cumulativeDelta = 0;

    const flightsData = flights.map(flight => {
      cumulativeDelta += flight.delta;
      return {
        Fecha: flight.departureDate,
        Material: flight.groupTypeMaster,
        Matrícula: flight.registration,
        Piloto: flight.userPilot,
        Instructor: flight.userInstructor || '',
        Tipo: flight.flightType,
        Duración: minutesToHHMM2(flight.delta),
        Acumulado: minutesToHHMM2(cumulativeDelta),
      };
    });
    exportToExcel(flightsData, `bitacora_vuelos_${parameters.startDate}_a_${parameters.endDate}.xlsx`);
  }
  const handleGetFlight = async (id: number) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/flights/flight',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({ idFlight: id }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setFlight(data.flight);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleFlightsSearch = async () => {
    try {
      setLoading(true)
      let body: any = {
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        pilotType: parameters.pilotType ? parameters.pilotType : '',
        orderBy: "departureDate",
        order: "desc",
      }
      if (parameters.groupTypeMasterCode && parameters.groupTypeMasterCode.value != '') {
        //body = { ...body, groupTypeMasterCode: parameters.groupTypeMasterCode.value }
      }
      if (parameters.idEquipment && parameters.idEquipment > 0) {
        body = { ...body, idEquipment: parameters.idEquipment }
      }
      if (parameters.idCategories && parameters.idCategories.length > 0) {
        body = { ...body, idCategories: parameters.idCategories }
      }
      if (parameters.idGroupTypes && parameters.idGroupTypes.length > 0) {
        body = { ...body, idGroupTypes: parameters.idGroupTypes }
      }
      if (parameters.idFlightTypes && parameters.idFlightTypes.length > 0) {
        body = { ...body, idFlightTypes: parameters.idFlightTypes }
      }
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/flights/list',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setFlights(data.flights);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const totalFilters = parameters.idCategories?.length + parameters.idGroupTypes?.length + parameters.idFlightTypes?.length;

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      splitPanel={
        <SidePanelFlight flight={flight} />
      }
      splitPanelOpen={!!flight}
      onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "cma/equipments/logs" : null}
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Bitácora de vuelos</Header>
          <SpaceBetween direction="horizontal" size="xs">
            <Box textAlign='left'>
              <SpaceBetween direction="vertical" size="xs">
                <SpaceBetween direction="horizontal" size="xs">
                  <FormField label="Material">
                    <SelectEquipment


                      onConfirm={(equipment: ItemEquipment | undefined) => {
                        if (equipment)
                          setParameters({ ...parameters, idEquipment: equipment.idEquipment });
                        else
                          setParameters({ ...parameters, idEquipment: 0 });
                      }}
                      value={parameters.idEquipment}
                    />
                  </FormField>

                  <FormField label="Rango de fechas">
                    <DRPicker
                      start={parameters.startDate || ''}
                      end={parameters.endDate || ''}

                      onConfirm={(start: string, end: string) => {
                        setParameters({ ...parameters, startDate: start, endDate: end });

                      }}
                    />
                  </FormField>
                  <FormField label="&nbsp;">
                    <Button style={{ root: btnIconForm }} onClick={() => setAdvanceFilter(!advanceFilter)}>
                      <SpaceBetween direction="horizontal" size="xs">
                        {advanceFilter ? <Icon path={mdiFilterMultiple} size={1} /> : <Icon path={mdiFilterMenuOutline} size={1} />}
                        {totalFilters > 0 ? totalFilters : null}
                      </SpaceBetween>
                    </Button>
                  </FormField>
                  <FormField label="&nbsp;">
                    <SpaceBetween direction="horizontal" size="xs">

                      <Button style={{ root: btnIconForm }} disabled={!parameters.idEquipment || parameters.idEquipment === 0} onClick={() => {
                        if (window.location.hash.includes("?id=")) {
                          window.location.hash = "cma/equipments/logs";
                        }
                        handleFlightsSearch()
                      }}><Icon path={mdiMagnify} size={1} /></Button>

                    </SpaceBetween>
                  </FormField>

                </SpaceBetween>
                {advanceFilter && (
                  <SpaceBetween direction="vertical" size="xs">
                    <SpaceBetween direction="horizontal" size="xs">
                      <FormField label="Categoría">
                        <SelectCategory single={false} onSelect={(idCategories) => {
                          setParameters({ ...parameters, idCategories: idCategories });
                        }} value={parameters.idCategories} hideTokens={false} tokenLimit={0}
                        />
                      </FormField>

                      <FormField label="Grupo">
                        <SelectGroupType single={false} onSelect={(idGroupTypes) => {
                          setParameters({ ...parameters, idGroupTypes: idGroupTypes });
                        }} value={parameters.idGroupTypes} hideTokens={false} tokenLimit={0}
                        />
                      </FormField>
                      <FormField label="Tipo de vuelo">
                        <SelectFlightType single={false} onSelect={(idFlightTypes) => {
                          setParameters({ ...parameters, idFlightTypes: idFlightTypes });
                        }} value={parameters.idFlightTypes} hideTokens={false} tokenLimit={0}

                        />
                      </FormField>
                    </SpaceBetween>
                  </SpaceBetween>
                )}
              </SpaceBetween>
            </Box>
          </SpaceBetween >
          <TableFlights flights={flights} onSelect={(fl: ItemFlight) => window.location.hash = `cma/equipments/logs?id=${fl.idFlight}`}
            showSoftMantto excel footer showEquipment={false} />


        </SpaceBetween >
      }
    />
  )
};

